import { Location, To } from "react-router-dom-v5-compat";

import { PartialLocation } from "common/types/routing";

import {
  StateParamType,
  type,
  Validator
} from "seneca-common/utils/routing/react-router-typesafe-routes/common";

import {
  AssignmentSpecType,
  CreateAssignmentSource
} from "features/teachers/features/assignment-journey/consts";
import { SchoolQuoteSources } from "features/teachers/pages/what-is-premium/analytics/consts";

export const locationType: StateParamType<Location, PartialLocation> = {
  getPlainStateParam(value: PartialLocation) {
    return value;
  },
  getTypedStateParam(value) {
    return value as Location;
  }
};

export const anyValidator: Validator<any> = (value: unknown): any => {
  return value as any;
};

export const toValidator: Validator<To> = (value: unknown): To => {
  return value as To;
};

const schoolQuoteSourcesValidator: Validator<SchoolQuoteSources> = (
  value: unknown
): SchoolQuoteSources => {
  return value as SchoolQuoteSources;
};

export const schoolQuoteSourcesType = type(schoolQuoteSourcesValidator);

const createAssignmentSourceValidator: Validator<CreateAssignmentSource> = (
  value: unknown
): CreateAssignmentSource => {
  return value as CreateAssignmentSource;
};

export const createAssignmentSourceType = type(createAssignmentSourceValidator);

const assignmentSpecTypeValidator: Validator<AssignmentSpecType> = (
  value: unknown
): AssignmentSpecType => {
  return value as AssignmentSpecType;
};

export const assignmentSpecTypeType = type(assignmentSpecTypeValidator);
